import { render, staticRenderFns } from "./QualificationsEdit.vue?vue&type=template&id=6726d3b6&scoped=true&"
import script from "./QualificationsEdit.vue?vue&type=script&lang=js&"
export * from "./QualificationsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6726d3b6",
  null
  
)

export default component.exports